import React from "react";
import { AppBar, Toolbar } from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import haveAccess from "../../../utilities/functions/haveAccess";
import { ReactComponent as HomeIcon } from "./../../../assets/images/icons/Google SVGs/home.svg";
import { ReactComponent as CalendarAddOnIcon } from "./../../../assets/images/icons/Google SVGs/calendar_add_on.svg";
import { ReactComponent as CalendarMonthMineIcon } from "./../../../assets/images/icons/Google SVGs/calendar_month_mine.svg";
import { ReactComponent as CalendarMonthIcon } from "./../../../assets/images/icons/Google SVGs/calendar_month.svg";
import { ReactComponent as SupportAgentIcon } from "./../../../assets/images/icons/Google SVGs/support_agent.svg";
import constData from "../../../utilities/const.json";

const Appbar = () => {
  const { roles } = useSelector((state) => state.user);
  const isMobile = window.innerWidth >= 992 ? false : true;

  return (
    <AppBar
      position="fixed"
      color=""
      sx={{
        top: "auto",
        bottom: 0,
        zIndex: 1049,
        borderTop: "solid 1px #ced4da",

        boxShadow: "0px -4px 10px 0px #0000000D,0px -1px 4px 0px #0000000D",
      }}
    >
      <Toolbar
        className="btn-group px-12px py-2 fs-14"
        role="group"
        aria-label="Basic example"
      >
        <a
          className="d-flex nav-link justify-content-center col col-4"
          type="button"
          href="/"
          onClick={() => {
            localStorage.setItem(
              "callBackURL",
              window.location.pathname + window.location.search
            );
          }}
        >
          <div
            className={`d-flex w-100 flex-column align-items-center pb-1 ${
              window.location.pathname === "/"
                ? "color-iso-blue-300 fw-medium"
                : "color-bootstrap-gray-600"
            }`}
          >
            <HomeIcon width={32} height={32} />
            خانه
          </div>
        </a>
        {haveAccess(roles, "menu_set-event") && (
          <a
            className="d-flex nav-link justify-content-center col col-4"
            type="button"
            href="/book-appointment"
          >
            <div
              className={`d-flex w-100 flex-column align-items-center pb-1 ${
                window.location.pathname === "/book-appointment"
                  ? "color-iso-blue-300 fw-medium"
                  : "color-bootstrap-gray-600"
              }`}
            >
              <CalendarAddOnIcon width={32} height={32} />
              ثبت نوبت
            </div>
          </a>
        )}
        {haveAccess(roles, "turns_page") && (
          <a
            className="nav-link d-flex justify-content-center col col-4"
            type="button"
            href="/turns"
          >
            <div
              className={`d-flex w-100 flex-column align-items-center pb-1 ${
                window.location.pathname === "/turns"
                  ? "color-iso-blue-300 fw-medium"
                  : "color-bootstrap-gray-600"
              }`}
            >
              <CalendarMonthIcon width={32} height={32} />
              نوبت مراجعین
            </div>
          </a>
        )}
        {!haveAccess(roles, "turns_page") &&
          haveAccess(roles, "myturns_page") && (
            <a
              className="nav-link d-flex justify-content-center col col-4"
              type="button"
              href="/my-turns"
            >
              <div
                className={`d-flex w-100 flex-column align-items-center pb-1 ${
                  window.location.pathname === "/my-turns"
                    ? "color-iso-blue-300 fw-medium"
                    : "color-bootstrap-gray-600"
                }`}
              >
                <CalendarMonthMineIcon
                  className="pt-1"
                  width={32}
                  height={32}
                />
                نوبت‌های من
              </div>
            </a>
          )}
        {!haveAccess(roles, "menu_set-event") && (
          <a
            className="d-flex nav-link justify-content-center col col-4"
            type="button"
            href="tel:09156510022"
          >
            <div
              className={`d-flex w-100 flex-column align-items-center pb-1 color-bootstrap-gray-600`}
            >
              <SupportAgentIcon width={32} height={32} />
              ارتباط با پشتیبانی
            </div>
          </a>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Appbar;
